import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';

export const GlassCard = ({ 
    children, 
    className = '', 
    variant = 'light',
    hover = true,
    ...props 
}) => {
    const variants = {
        light: 'glass-card',
        dark: 'glass-card-dark',
    };

    return (
        <motion.div
            className={cn(
                variants[variant],
                'rounded-3xl p-6 md:p-8',
                hover && 'card-hover',
                className
            )}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            {...props}
        >
            {children}
        </motion.div>
    );
};

export const FloatingCard = ({ 
    children, 
    className = '',
    delay = 0,
    ...props 
}) => {
    return (
        <motion.div
            className={cn(
                'glass-card rounded-3xl p-6 md:p-8 floating',
                className
            )}
            initial={{ opacity: 0, y: 30, scale: 0.95 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay }}
            {...props}
        >
            {children}
        </motion.div>
    );
};
